import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var MinusCircle = createReactComponent("MinusCircle", ["svg", defaultAttributes, [["circle", {
  cx: "12",
  cy: "12",
  r: "10",
  key: "14id60"
}], ["line", {
  x1: "8",
  y1: "12",
  x2: "16",
  y2: "12",
  key: "6hnc9b"
}]]]);
export default MinusCircle;